import React, { useState } from "react";
import DashboardSide from "../dashboard/DashboardSide";
import SuccessCenter from "./SuccessCenter";
import MobileMenu from "../dashboard/MobileMenu";

export default function Success() {
  const [modal, setModal] = useState(false);

  return (
    <div className="h-full bg-[#f6f6f6] flex items-center justify-center">
      <DashboardSide />
      {modal && <MobileMenu setModal={setModal} />}
      <SuccessCenter setModal={setModal} />
    </div>
  );
}
